<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="600px"
    top="20vh"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <!-- 招商信息表单 -->
    <el-form
      ref="checkinFormRef"
      :model="formData"
      :rules="formRules"
      label-width="110px"
      label-position="right"
      class="checkin-form"
    >
      <!-- 登记日期 -->
      <el-form-item label="登记日期" prop="registerDate">
        <el-date-picker
          v-model="formData.registerDate"
          type="date"
          :disabled="isEdit"
          placeholder="请选择登记日期"
          style="width: 100%"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>

      <!-- 招商状态 -->
      <el-form-item label="招商状态" prop="status">
        <el-select
          v-model="formData.status"
          placeholder="请选择招商状态"
          style="width: 100%"
          clearable
        >
          <el-option label="已签约" value="已签约" />
          <el-option label="待签约" value="待签约" />
          <el-option label="沟通中" value="沟通中" />
          <el-option label="已放弃" value="已放弃" />
          <el-option label="暂停" value="暂停" />
        </el-select>
      </el-form-item>

      <!-- 商户名称 -->
      <el-form-item label="商户名称" prop="merchantName">
        <el-input
          v-model="formData.merchantName"
          placeholder="请输入商户全称"
          maxlength="100"
          show-word-limit
        />
      </el-form-item>

      <!-- 行业类别 -->
      <el-form-item label="行业类别" prop="industryType">
        <el-select
          v-model="formData.industryType"
          placeholder="请选择行业类别"
          style="width: 100%"
          clearable
        >
          <el-option label="人工智能" value="人工智能" />
          <el-option label="餐饮美食" value="餐饮美食" />
          <el-option label="娱乐休闲" value="娱乐休闲" />
          <el-option label="快递服务" value="快递服务" />
          <el-option label="美容美发" value="美容美发" />
          <el-option label="医疗卫生" value="医疗卫生" />
          <el-option label="生活配套" value="生活配套" />
          <el-option label="超市" value="超市" />
          <el-option label="其他" value="其他" />
        </el-select>
      </el-form-item>

      <!-- 需求面积 -->
      <el-form-item label="需求面积(㎡)" prop="demandArea">
        <el-input-number
          v-model="formData.demandArea"
          :min="0.1"
          :max="99999.9"
          step="0.1"
          placeholder="请输入建筑面积"
          style="width: 100%"
        />
      </el-form-item>

      <!-- 所选位置 -->
      <el-form-item label="所选位置" prop="selectPosition">
        <el-input
          v-model="formData.selectPosition"
          placeholder="例：科创中心3层01区/邻里中心1层05铺"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>

      <!-- 租金政策 -->
      <el-form-item label="租金政策" prop="rentPolicy">
        <el-select
          v-model="formData.rentPolicy"
          placeholder="请选择租金政策"
          style="width: 100%"
          clearable
        >
          <el-option label="实缴租金" value="实缴租金" />
          <el-option label="租金优惠" value="租金优惠" />
          <el-option label="合作联营" value="合作联营" />
          <el-option label="其他" value="其他" />
        </el-select>
      </el-form-item>

      <!-- 商户联系人 -->
      <el-form-item label="商户联系人" prop="contactPerson">
        <el-input
          v-model="formData.contactPerson"
          placeholder="请输入商户对接人姓名"
          maxlength="50"
          show-word-limit
        />
      </el-form-item>

      <!-- 联系方式 -->
      <el-form-item label="联系方式" prop="contactWay">
        <el-input
          v-model="formData.contactWay"
          placeholder="请输入电话/微信等联系方式"
          maxlength="100"
          show-word-limit
        />
      </el-form-item>

      <!-- 招商负责人 -->
      <el-form-item label="招商负责人" prop="principal">
        <el-input
          v-model="formData.principal"
          placeholder="请输入园区招商对接人"
          maxlength="50"
          show-word-limit
        />
      </el-form-item>

      <!-- 进展情况 -->
      <el-form-item label="进展情况" prop="progress">
        <el-input
          type="textarea"
          v-model="formData.progress"
          placeholder="请输入当前招商对接进展"
          rows="3"
          maxlength="500"
          show-word-limit
        />
      </el-form-item>

      <!-- 备注 -->
      <el-form-item label="备注信息" prop="remark">
        <el-input
          type="textarea"
          v-model="formData.remark"
          placeholder="请输入补充说明信息"
          rows="3"
          maxlength="1000"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <!-- 弹窗底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "StoreInformationDialog",
  // 接收主页面传递的参数
  props: {
    // 弹窗显隐状态
    visible: {
      type: Boolean,
      default: false
    },
    // 表单数据（新增为空/编辑为回显数据）
    formData: {
      type: Object,
      default: () => ({})
    },
    // 是否为编辑模式（true=编辑，false=新增）
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 表单双向绑定数据（深拷贝避免修改主页面原数据）
      localForm: {},
      // 表单验证规则（核心字段必填，贴合业务）
      formRules: {
        registerDate: [
          { required: true, message: "请选择登记日期", trigger: "change" }
        ],
        status: [
          { required: true, message: "请选择招商状态", trigger: "change" }
        ],
        merchantName: [
          { required: true, message: "请输入商户名称", trigger: "blur" },
          { min: 2, max: 100, message: "商户名称长度2-100字符", trigger: "blur" }
        ],
        industryType: [
          { required: true, message: "请选择行业类别", trigger: "change" }
        ],
        demandArea: [
          { required: true, message: "请输入需求面积", trigger: "blur" }
        ],
        rentPolicy: [
          { required: true, message: "请选择租金政策", trigger: "change" }
        ],
        contactPerson: [
          { required: true, message: "请输入商户联系人", trigger: "blur" },
          { min: 2, max: 50, message: "联系人长度2-50字符", trigger: "blur" }
        ],
        contactWay: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { min: 2, max: 100, message: "联系方式长度2-100字符", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    // 监听主页面传递的formData，同步到本地表单（深拷贝）
    formData: {
      handler(newVal) {
        this.localForm = JSON.parse(JSON.stringify(newVal));
        // 新增时默认填充当前日期为登记日期
        if (!this.isEdit && !this.localForm.registerDate) {
          const now = new Date();
          const year = now.getFullYear();
          const month = (now.getMonth() + 1).toString().padStart(2, '0');
          const day = now.getDate().toString().padStart(2, '0');
          this.localForm.registerDate = `${year}-${month}-${day}`;
        }
        // 新增时默认招商状态为“沟通中”
        if (!this.isEdit && !this.localForm.status) {
          this.localForm.status = "沟通中";
        }
      },
      immediate: true,
      deep: true
    },
    // 监听弹窗显隐，重置表单验证
    visible(newVal) {
      if (!newVal && this.$refs.checkinFormRef) {
        this.$refs.checkinFormRef.clearValidate();
      }
    }
  },
  computed: {
    // 弹窗标题：根据编辑/新增模式动态变化
    dialogTitle() {
      return this.isEdit ? "编辑招商登记信息" : "新增招商登记信息";
    }
  },
  methods: {
    /**
     * 关闭弹窗：向主页面派发close事件
     */
    handleClose() {
      this.$emit("close");
    },

    /**
     * 提交表单：验证通过后向主页面派发save事件，传递表单数据
     */
    handleSubmit() {
      this.$refs.checkinFormRef.validate((valid) => {
        if (valid) {
          // 验证通过，派发save事件
          this.$emit("save", this.localForm);
        } else {
          // 验证失败，提示错误
          this.$message.error("表单填写有误，请检查必填项！");
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.checkin-form {
  padding: 10px 0;
}

.dialog-footer {
  text-align: center;
}

/* 适配输入框/选择器样式，和主页面统一 */
.el-input,
.el-select,
.el-input-number,
.el-date-picker {
  font-size: 14px;
}

.el-form-item {
  margin-bottom: 18px;
}
</style>